import { getFetch, postFetchWithBody, postFetchWithToken } from "../../utils/fetch";

async function getJensCodes(page,term) {
  const data = await getFetch(`/JensCode?${page}`);
  console.log(data);
  if (data.status !== "error") {
    return {
      status: "success",
      message: data,
    };
  } else {
    return {
      status: data.status,
      message: "خطا در اتصال به سرور!",
    };
  }
}
async function storeJensCode(form) {
  if (form.get('code') === '') {
    return {
      status: 'error',
      message: ' کد کالا الزامی است!',
    }
  }

  const res = await postFetchWithToken("/JensCode/store", form);
  if(res.status !== 'error'){
    return {
      status:'success',
      message:'کد کالا با موفقیت ایجاد شد'
    }
  }else{
    return {
      status:res.status,
      message:res.message
    }
  }
}
async function deleteJensCode(id) {
  const res = await postFetchWithBody(`/JensCode/delete`, { id: id });
  if (res.status !== "error") {
    return {
      status: "success",
      message: res,
    };
  } else {
    return {
      status: res.status,
      message: "خطا در اتصال به سرور!",
    };
  }
}
export { getJensCodes, storeJensCode,deleteJensCode };
